<script setup>
import LandingHero from '@/components/landing/LandingHero.vue';
import LandingWhyCyberalarm from '@/components/landing/LandingWhyCyberalarm.vue';
import LandingHowItWorks from '@/components/landing/LandingHowItWorks.vue';
import LandingCourses from '@/components/landing/LandingCourses.vue';
import LandingAboutUs from '@/components/landing/LandingAboutUs.vue';
import LandingPrices from '@/components/landing/LandingPrices.vue';
import LandingAlarm from '@/components/landing/LandingAlarm.vue';
</script>

<template>
  <section
    id="top"
    class="mt-24"
  >
    <LandingHero />
  </section>

  <section
    class="pt-section"
    id="why-cyberalarm"
  >
    <LandingWhyCyberalarm />
  </section>

  <section id="how-it-works">
    <LandingHowItWorks />
  </section>
  <section id="alarm">
    <LandingAlarm />
  </section>

  <section id="courses">
    <LandingCourses />
  </section>

  <section id="about-us">
    <LandingAboutUs />
  </section>

  <section id="pricing">
    <LandingPrices />
  </section>
</template>

<style scoped>

</style>
